import { Link } from "react-router-dom";
import { Brand } from "@/components/Brand";

export default function NotFound() {
  return (
    <div className="min-h-screen grid place-items-center bg-background px-6" data-testid="not-found">
      <div className="max-w-md text-center">
        <div className="mb-6 flex justify-center"><Brand /></div>
        <p className="font-mono text-primary text-sm">404</p>
        <h1 className="font-display text-3xl font-bold text-slate-50 mt-1">Page not found</h1>
        <p className="text-sm text-slate-400 mt-2">The page you're looking for doesn't exist or has moved.</p>
        <Link to="/" className="inline-block mt-6 h-10 px-4 leading-10 rounded-lg bg-primary hover:bg-emerald-600 text-white text-sm font-medium" data-testid="notfound-home-btn">
          Back to home
        </Link>
      </div>
    </div>
  );
}
